var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "ul",
    { staticClass: "recipients-list" },
    _vm._l(_vm.recipients, function (recipient, index) {
      return _c("li", { key: index, staticClass: "audit-grid-item" }, [
        _vm._v(_vm._s(recipient)),
      ])
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }